import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';

import {AppComponent} from './app.component';
import {DocketService} from './docket.service';
import {LocationService} from './location.service';

import {FormControl, Validators} from '@angular/forms';

import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';

@Component({
    selector: 'app-location',
    templateUrl: './templates/location.component.html',
    styleUrls: ['./styles/location.component.css'],
    providers: [DocketService, SortTable]
})
export class LocationComponent implements OnInit {

    id_docket: any;
    docket_details_list: any;

    invalid_list: Array<any>;
    art_list: Array<any>;
    article_selected_list: Array<string> = [];
    article_list: Array<string> = [];
    empty_list: boolean = true;

    operation_bt: string = 'ok';

    emplacement: string = '';
    emplacementCtrl: FormControl;

    articles_list_popup: Array<any>;
    articles_session: Array<any> = [];
    sortedData: any = [];

    constructor(
        private router: Router,
        private location_service: LocationService,
        private activated_route: ActivatedRoute,
        private app_component: AppComponent,
        private sort_table: SortTable
    ) {
        this.emplacementCtrl = new FormControl('', Validators.required);
    }

    ngOnInit() {
        this.isDocketUnplaced();
        this.getDocketDetails();
        this.getSessionLocation();
    }

    EditAndValidateModification(lot: any) {
        if (lot.status === "NONE") {
            lot.status = 'EDIT';
            console.log('ato');
        } else if (lot.status === 'EDIT') {
            console.log('edit');
            console.log(lot.status);
            this.validateEditLotSession(lot);

        }
    }

    validateEditLotSession(article: any): void {
        if (isNaN(article.quantity)) {
            article.quantity = 1;
        }
        this.location_service.validateEditLotSession(article)
            .then(result => {
                let articles_session = result;
            });
    }

    operationBt() {
        if (this.article_selected_list.length != 0) {
            let checked_list = this.article_selected_list.join('_');
            console.log(checked_list);
            this.add_location = true;
            this.app_component.hide_wrapper(this.add_location);

            this.location_service.placeLots(checked_list)
                .then(result => {
                    this.articles_list_popup = result['list'];
                });
        }
    }

    isDocketUnplaced() {
        this.id_docket = this.getParam();
        this.location_service.isDocketUnplaced(this.id_docket)
            .then(result => {
                let is_unplaced = result['unplaced_dockets'];
                if (is_unplaced === 'T') {
                    this.router.navigate(['/location-management'], {});
                }
            });
    }

    getParam(): number {
        let id = 0;
        this.activated_route.params.subscribe((params: Params) => {
            id = params['id_docket'];
        });
        return id;
    }

    getDocketDetails(): void {
        this.location_service.getDocketDetails(this.id_docket)
            .then(result => {
                this.article_list = result['list'];
                this.sortedData = result['list'];
                this.sort_table.SetDataArray(result['list'], [{value: "article_name", type: ""}, {value: "serial", type: ""}, {value: "quantity_to_place", type: "number"}]);
            });
    }

    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
        // recupérer  data
    }

    getSessionLocation(): void {
        this.location_service.getSessionLocation(this.id_docket)
            .then(result => {
                this.articles_session = result['list'];
            });
    }

    //    case
    isChecked(): boolean {
        return this.article_selected_list.length === this.article_list.length;
    }

    isIndeterminate(): boolean {
        return (this.article_selected_list.length !== 0 &&
            this.article_selected_list.length !== this.article_list.length);

    }

    toggleAll(): void {
        if (this.article_selected_list.length === this.article_list.length) {
            this.article_selected_list = [];
        } else if (this.article_selected_list.length === 0 || this.article_selected_list.length > 0) {
            for (let i = 0; i < this.article_list.length; i++) {
                this.article_selected_list[i] = this.article_list[i]['id_movement'];
            }
        }
    }

    Exists(id_article: string, selected: Array<string>): boolean {
        return selected.indexOf(id_article) > -1;
    }

    Toggle(id_article: string, selected: Array<string>): void {
        var index = selected.indexOf(id_article);
        if (index > -1) {
            selected.splice(index, 1);
        }
        else {
            selected.push(id_article);
        }
    };

    //    popup
    add_location: boolean = false;
    docket_infos: string = '';

    InitPopup(): void {
        this.emplacement = '';
        this.emplacementCtrl.reset();
        this.add_location = false;
        this.app_component.hide_wrapper(this.add_location);
    }

    Cancel(): void {
        this.InitPopup();
        this.emplacementCtrl.reset();
        this.emplacementCtrl.setValue('');
        this.emplacement = '';
    }
    erreur: boolean = false;
    btnAdd(): void {
        if (this.emplacementCtrl.status === 'VALID') {
            var id = this.articles_list_popup[0].id_movement;
            var quantity = this.articles_list_popup[0].quantity_to_place;
            for (var i = 1; i < this.articles_list_popup.length; i++) {
                id = id + "_" + this.articles_list_popup[i].id_movement;
                quantity = quantity + "_" + this.articles_list_popup[i].quantity_to_place;
            }
            this.location_service.validateEditLotSession2(this.emplacement, id, quantity)
                .then(result => {
                    this.articles_session = result['list_right'];
                    this.article_list = result['list_left'];
                    this.sortedData = result['list_left'];
                    this.sort_table.SetDataArray(result['list_left'], [{value: "article_name", type: ""}, {value: "serial", type: ""}, {value: "quantity_to_place", type: "number"}]);
                    console.log(this.articles_session);
                });
            this.InitPopup();
            this.article_selected_list = [];
            this.emplacementCtrl.reset();
            this.emplacementCtrl.setValue('');
            this.emplacement = '';
        } else {
            this.erreur = true;
        }
    }

    //placer
    PlacerBt(): void {
        this.location_service.saveSessionLocation().then(result => {
            this.articles_session = result['list_right'];
            this.article_list = result['list_left'];
            this.sortedData = result['list_left'];
            this.sort_table.SetDataArray(result['list_left'], [{value: "article_name", type: ""}, {value: "serial", type: ""}, {value: "quantity_to_place", type: "number"}]);
            if (this.article_list.length === 0) {
                this.router.navigate(['/location-management'], {});
            }
        });
        this.article_selected_list = [];
    }

    resetBt(): void {
        this.emplacementCtrl.reset();
        this.emplacementCtrl.setValue('');
        this.emplacement = '';
        this.location_service.getDocketDetails(this.id_docket).then(result => {
            this.article_list = result['list'];
            this.sortedData = result['list'];
            this.sort_table.SetDataArray(result['list'], [{value: "article_name", type: ""}, {value: "serial", type: ""}, {value: "quantity_to_place", type: "number"}]);
            this.articles_session = [];
        });
    }

    //    other
    Clean(str: string): string {
        var space = String.fromCharCode(160);
        var res_1 = String(str).replace('&nbsp;', ' ');
        var res_2 = String(res_1).replace(new RegExp(space, 'gi'), ' ');
        return res_2;
    }

    CleanFormatPrice(str_price: string): number {
        var str_price = this.Clean(str_price);
        var no_space = str_price.split(' ');
        return parseInt(no_space.join(''));
    }

    FormatPriceBying(article: any, price: string): void {

        if (price !== "") {
            let clean_price = this.CleanFormatPrice(price);
            article.quantity_to_place = clean_price;
            if (!isNaN(Number(clean_price))) {
                if (article.quantity_to_place <= article.last_quantity) {
                    article.quantity_to_place = Math.round(clean_price).toLocaleString();// + ' Ar';
                } else {
                    article.quantity_to_place = article.last_quantity;
                }
            } else {
                article.quantity_to_place = "0";
            }
        } else {
            article.quantity_to_place = "0";
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/location.component.ts